import React from 'react';
type ScarcityBarProps = {
  tone?: 'dark' | 'light';
  spots?: number;
  percent?: number;
};
export function ScarcityBar({
  tone = 'dark',
  spots = 23,
  percent = 89
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl p-4 sm:p-5 ${isDark ? 'bg-graphite/70 ring-1 ring-white/10' : 'bg-white ring-1 ring-ink/10 shadow-card'}`} data-id="element-51" data-mp="2l4ejw2yisujv">
      <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-52" data-mp="2b56ycshmttlo">
        <span className={`text-sm font-extrabold ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-53" data-mp="2g6mjekjt8042">
          Only {spots} spots remaining
        </span>
        <span className="text-sm font-extrabold text-blood tabular-nums" data-id="element-54" data-mp="274vbra5plj7k">
          {percent}% claimed
        </span>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/12' : 'bg-ink/10'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots claimed" data-id="element-55" data-mp="fql68towlfr">
        <div className="h-full rounded-full bg-blood" style={{
        width: `${percent}%`
      }} data-id="element-56" data-mp="2zki360zhrnbl" />
      </div>

      <p className={`mt-3 text-xs leading-relaxed ${isDark ? 'text-white/65' : 'text-graphite/70'}`} data-id="element-57" data-mp="3deskvyd2mh85">
        {percent}% of the launch spots have already been claimed. Once they’re
        gone, the price returns to <strong className="font-bold" data-id="element-58" data-mp="2gmxbyn998cnt">$247 USD</strong>.
      </p>
    </div>;
}